import { mapState, mapActions } from 'vuex';
import marketHeaderTitle from '@/components/market/market-header-title/market-header-title.vue';
import purchaseJourney from '@/components/purchase/purchase-journey/purchase-journey.vue';
import constants from '@/constants';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    marketHeaderTitle,
    purchaseJourney,
  },
  props: {
    market: {},
  },
  data() {
    return {
      ready: false,
      confirmationShown: false,
    };
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions', 'clearOrderBook']),
    ...mapActions('popup', ['setCurrentPopup', 'setTradePopupOptions']),
    onClose() {
      this.setCurrentPopup();
      this.setTradePopupOptions({});
      // this.setTradeOptions(null);
    },
    onConfirmationDataChange(val) {
      this.confirmationShown = !!val;
    },
    afterEnter() {
      if (constants.POPUP_OVERFLOW_MODE) {
        setTimeout(() => window.scrollTo(0, 0), 0);
      }

      if (!this.ready) {
        this.ready = true;
        this.loaderRemove(document.body);
      }
    },
  },
  computed: {
    ...mapState('trade', ['tradeOptions']),
    showCloseButton() {
      return true; // return !this.confirmationShown;
    },
  },
  created() {
    this.loaderAdd(document.body);
  },
  beforeDestroy() {
    this.clearOrderBook();
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/purchase-modal/purchase-modal.js